// extracted by mini-css-extract-plugin
export default {"root":"q0gNSE","bg":"gudkcV","arrow":"mgZCVu"};